module.exports = __webpack_public_path__ + "img/flagUAH.ff4f4458.svg";